const RSVPComponent = (props: any) => {
    
    const iframeSrc: string = props.iframeSrc
    const parentWidth: number = props.parentWidth

    return (
        <>
        <div>
            <iframe 
                src={iframeSrc} height="1145" width={parentWidth} style={{margin: "auto"}}>
                    Loading…
            </iframe>   
        </div>
        </>
    )

}

export default RSVPComponent